import Cipher from '../cipher';
import { EStorageKey, IStorage } from './types';

class Storage implements IStorage {
  setItem(key: EStorageKey, value: unknown): void {
    try {
      const encrypted = Cipher.encrypt(key, JSON.stringify(value));
      localStorage.setItem(key, JSON.stringify(encrypted));
    } catch (e) {}
  }

  getItem(key: EStorageKey) {
    try {
      const data = localStorage.getItem(key);

      if (data) {
        const decrypted = Cipher.decrypt(key, JSON.parse(data));
        return decrypted ? JSON.parse(decrypted) : undefined;
      }

      return undefined;
    } catch (e) {
      return undefined;
    }
  }

  removeItem(key: EStorageKey) {
    localStorage.removeItem(key);
  }
}

export default new Storage();
